export const GET_CLIENT_PROGRESS_IMAGES_SUCCESS =
  'Client/GET_CLIENT_PROGRESS_IMAGES_SUCCESS';
export const GET_CLIENT_PROGRESS_IMAGES_APPEND_SUCCESS =
  'Client/GET_CLIENT_PROGRESS_IMAGES_APPEND_SUCCESS';
export const GET_CLIENT_PROGRESS_IMAGES_ERROR =
  'Client/GET_CLIENT_PROGRESS_IMAGES_ERROR';
export const GET_CLIENT_PROGRESS_IMAGES_SUMMARY_SUCCESS =
  'Client/GET_CLIENT_PROGRESS_IMAGES_SUMMARY_SUCCESS';
export const GET_GRAPHS_DATA_SUCCEED = 'Client/GET_GRAPHS_DATA_SUCCEED';
export const GET_GRAPHS_DATA_ERROR = 'Client/GET_GRAPHS_DATA_ERROR';
export const GET_CLIENT_TRACK_SUCCEED = 'Client/GET_CLIENT_TRACK_SUCCEED';
export const GET_CLIENT_TRACK_ERROR = 'Client/GET_CLIENT_TRACK_ERROR';
export const RESET_GRAPHS_LOADING_STATE = 'Client/RESET_GRAPHS_LOADING_STATE';
export const EDIT_CLIENT_TRACK_SUCCEED = 'Client/EDIT_CLIENT_TRACK_SUCCEED';
export const EDIT_CLIENT_TRACK_ERROR = 'Client/EDIT_CLIENT_TRACK_ERROR';
export const LOADING_CLIENT_TRACK_STATE = 'Client/LOADING_CLIENT_TRACK_STATE';

